import * as React from 'react';
import { useState } from 'react';
import Box from "@material-ui/core/Box";
import TipoRecoleccionLista from "./TipoRecoleccionLista";
import RecoleccionFecha from "./RecoleccionFecha";
import { IRecoleccion } from "../../redux/types/recoleccionActionTypes";
import { connect } from "react-redux"
import { Button, createStyles, FormControl, Grid, InputLabel, makeStyles, MenuItem, Select, TextField, Theme } from "@material-ui/core";
import { enums } from "../../enums/enums";
import { ApplicationState } from "../../redux/reducers";
import SucursalComponente from "./Sucursal";
import NextButton from "../controls/NextButton";
import { initialRecoleccionState } from "../../redux/reducers/recoleccionReducer";
import ServicioAdicionalLista from "../servicioAdicional/servicioAdicionalLista";
import { IServicioAdicional, ServicioAdicional } from "../../entities/catalogos/ServicioAdicional";
import { Colonia } from "../../entities/catalogos/Colonia";
import { AreaServicio } from "../../entities/catalogos/AreaServicio";
import { Sucursal } from "../../entities/catalogos/Sucursal";
import { ICliente } from "../../entities/catalogos/ICliente";
import useCommonApi from "../../api/useCommonApi";
import { Solicitud } from "../../entities/solicitudes/Solicitud";
import { Add, Search } from '@material-ui/icons';

import RecoleccionDireccion from './RecoleccionDireccion';
import RecoleccionContacto from './RecoleccionContacto';
import AgregarDireccion from './AgregarDireccion';
import AgregarContacto from './AgregarContacto';
import AutocompleteControlSolicitud, { IAutocompleteSolicitud } from '../controls/AutocompleteControlSolicitud';
import { IUsuario } from '../../entities/catalogos/IUsuario';
import swal from 'sweetalert2';
import Help, { IHelp } from '../help/Help';
import { Autocomplete } from '@material-ui/lab';
import DatosComplementarios from './DatosComplementarios';
import { useSnackbar } from "notistack";
import { ICatalogo } from "../../entities/catalogos/ICatalogo";
import {
    completarValoresRecoleccion,
    getDireccionDistribuidor,
    obtenerServiciosAdicionales
} from "../../blocks/utility";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import { setSolicitud, setSolicitudCopia } from '../../redux/actions/solicitudActions';
import { forEach } from 'lodash';
import { element } from 'prop-types';
import LoadingDialog from '../controls/LoadingDialog';
import { saveCliente } from '../../redux/actions/clienteActions';
import { useContactosDistribuidor } from '../../contextos/contactosDistribuidorContext';
import { useContactosDistribuidorDestino } from '../../contextos/contactosDistribuidorDestinoContext';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        principal: {
            backgroundColor: "#fff",
            margin: "0px",
            padding: "10px",
        },
        container: {
            backgroundColor: "#e5e5e5",
        },
        label: {
            fontSize: '16px',
            fontWeight: 600
        },
        pais: {
            width: "120px"
        },
        icon: {
            width: "40px",
            height: "40px",
            minWidth: "40px",
            borderRadius: "20px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "center",
            paddingTop: "5px"
        },
        actions: {
            paddingTop: "30px",
        },
    }),
);


interface OwnProps {
    esOrigen: boolean
    value: IRecoleccion
    siguientePaso: (recoleccion: IRecoleccion, esOrigen: boolean, contacto: any) => void
    cotizacionId: number
}

interface StateProps {
    cliente: ICliente,
    solicitudCopia: Solicitud,
    usuario: IUsuario,
    ayuda: IHelp
    paises: ICatalogo[]
    recoleccionOrigen: IRecoleccion
    recoleccionDestino: IRecoleccion,
    changeIdioma: (idiomaId: string) => void
}

interface DispatchProps {
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
    saveCliente: typeof saveCliente
}


type Props = OwnProps & StateProps & DispatchProps

const RecoleccionSolicitud = ({ esOrigen, value, siguientePaso, cliente, solicitudCopia, cotizacionId,
    usuario, ayuda, paises, ...props }: Props) => {


    const codigoPostalInicial = value?.codigoPostal !== "" ? {
        id: value?.colonia?.id ? value?.colonia?.id : 0,
        colonia: {},
        calle: "",
        codigoPostal: value.codigoPostal.toString(),
        nombreClienteDistribuidor: "",
        parentId: Number(value.codigoPostal)
    } : null;

    const distribuidorInicial = value.distribuidor ||
        { id: 0, nombre: "", direccion: "", clienteDistribuidorID: 0, colonia: {}, codigoPostal: "", paisId: 0, estadoId: 0, ciudadId: 0, calle: '', noExterior: 0 };

    const { enqueueSnackbar } = useSnackbar();
    const classes = useStyles();
    const [recoleccion, setRecoleccion] = useState<IRecoleccion>(value);

    const [codigoPostal, setCodigoPostal] = useState<IAutocompleteSolicitud | null>(codigoPostalInicial);
    const apiSource = useCommonApi();

    const {contactosDistribuidor, setContactosDistribuidor} = useContactosDistribuidor();
    const {contactosDistribuidorDestino, setContactosDistribuidorDestino} = useContactosDistribuidorDestino();
    const [buscaDistribuidor, setBuscarDistribuidor] = useState(false);
    const [buscaContactos, setBuscarContactos] = useState(false);
    const [distribuidor, setDistribuidor] = useState(distribuidorInicial);
    const [contacto, setContacto] = useState(value.contacto);
    const [agregaDireccion, setNuevaDireccion] = useState(false);
    const [agregaContacto, setNuevoContacto] = useState(false);
    const [cpFueraArea, setCPFueraArea] = useState(false);
    const [showModalDatosComplementarios, setShowModalDatosComplementarios] = useState(false);
    const [showLoading, setLoading] = useState(false);

    React.useEffect(() => {
        if (esOrigen && value.distribuidor && 
            (contactosDistribuidor?.contactos?.length === 0 || contactosDistribuidor?.clienteId !== cliente.id 
                || contactosDistribuidor?.clienteDistribuidorId !== value.distribuidor.id)) {
                    getContactos(value.distribuidor.clienteDistribuidorID).then(res => {
                        if (res.length) {
                            //setContactosDistribuidor(res);
                            setContactosDistribuidor({clienteId: cliente.id, clienteDistribuidorId: value.distribuidor, contactos: res});
                        }
                    });
        }

        if (!esOrigen && value.distribuidor && 
            (contactosDistribuidorDestino?.contactos?.length === 0 || contactosDistribuidorDestino?.clienteId !== cliente.id 
                || contactosDistribuidorDestino?.clienteDistribuidorId !== value.distribuidor.id)) {
                    getContactos(value.distribuidor.clienteDistribuidorID).then(res => {
                        if (res.length) {
                            setContactosDistribuidorDestino({clienteId: cliente.id, clienteDistribuidorId: value.distribuidor, contactos: res});
                        }
                    });
        }

        //Si tiene codigo postal y no tiene servicios adicionales significa que viene de una cotización.
        if (value.codigoPostal && !value.serviciosAdicionales) {
            handleCodigoPostalGuardado(value).then();
        }
    }, [value]);

    React.useEffect(() => {
        var clienteNuevaConfig = localStorage.getItem("clienteString")?.toString() !==null ? (localStorage.getItem("clienteString")?.toString() !==undefined ? localStorage.getItem("clienteString") : "") :"" ;
        var clienteObject =  clienteNuevaConfig !== null ? (clienteNuevaConfig !== "" ? JSON.parse(clienteNuevaConfig) : "") : "";
        if(clienteObject !== ""){
            setLoading(true);
            localStorage.setItem("clienteString", "");
            getCPDist().then(res => {
               res.forEach( element => {
                    if(distribuidor.id === element.clienteDistribuidorID){
                        handleCodigoPostalRender(null, element).then();
                    }
               })
            });
            setLoading(false);
        }
        
    }, [localStorage.getItem("clienteString")]);

    React.useEffect(() => {
        const timer = setTimeout(() => {
            if ([recoleccion.fechaCita, recoleccion.fechaRecoleccion, recoleccion.fechaCitaCedis]
                .some(fecha => fecha !== null && fecha !== undefined)) {
                setLoading(false);
            }
        }, 1000);

        return () => clearTimeout(timer);
    }, [recoleccion]);

    const getCPDist = async () => {
        let paramsConv = {
            Texto: distribuidor.codigoPostal,
            paisId: distribuidor.paisId,
            clienteId: distribuidor.clienteID,
            userName: localStorage.getItem("usuario_nombre"),
            esOrigen: esOrigen
        }
        var result: any [] = await apiSource.obtenerAsync("cliente-distribuidor/by-codigo-postal",paramsConv);
        return result;
    }

    const handleCodigoPostalGuardado = async (optionSelected) => {
        setCodigoPostal(optionSelected.colonia);
        let colonia;

        colonia = new Colonia(optionSelected.colonia);
        let params ={
            paisId: colonia.pais?.id,
            estadoId: colonia.estado?.id,
            ciudadId: colonia.ciudad?.id,
            codigoPostal: colonia?.codigoPostal,
            empresaId: cliente?.empresaID,
            ClienteID: cliente?.id,
            ClienteDistribuidorID: optionSelected.distribuidor?.clienteDistribuidorID
        };
        const result: AreaServicio = await apiSource.obtenerAsync("area-servicio/by-address-cliente-distribuidor", params);
        const areaServicio: AreaServicio = new AreaServicio(result);
        const nuevaRecoleccion = {
            ...optionSelected,
            paisId: recoleccion.paisId,
            colonia: colonia,
            direccion: colonia.direccion,
            codigoPostal: colonia.codigoPostal,
            sinAreaServicio: areaServicio.id === 0,
            esServicioInternacional: recoleccion.paisId === enums.pais.usa,
            distribuidor: {
                id: optionSelected.distribuidor ? optionSelected.distribuidor.id : 0,
                nombre: optionSelected.distribuidor ? optionSelected.distribuidor.nombre : '',
                direccion: optionSelected.distribuidor ? optionSelected.distribuidor.direccion : '',
                clienteDistribuidorID: optionSelected.distribuidor ? optionSelected.distribuidor.clienteDistribuidorID : 0,
                colonia: optionSelected.distribuidor ? optionSelected.distribuidor.colonia : '',
                codigoPostal: optionSelected.distribuidor ? optionSelected.distribuidor.codigoPostal : '',
                paisId: optionSelected.distribuidor ? optionSelected.distribuidor.paisId : 0,
                estadoId: optionSelected.distribuidor ? optionSelected.distribuidor.estadoId : 0,
                ciudadId: optionSelected.distribuidor ? optionSelected.distribuidor.ciudadId : 0
            }
            
        };

        setDatosRecoleccionGuardada(areaServicio, nuevaRecoleccion);
    };

    const handleTipoDeRecoleccionOrigen = (
    tipo: number
    ) => {
        setRecoleccion(recoleccionActual => {
            const nuevaRecoleccion = {
                ...recoleccionActual,
                tipoDeRecoleccionOrigen: tipo
            };

            /*
            * Evitar que la bandera anterior de CEDIS
            * vuelva a marcar esa tarjeta.
            */
            if (tipo === 1) {
                delete nuevaRecoleccion.EsCitaRadCedis;
            }

            return nuevaRecoleccion;
        });
    };

    const obtenerParametrosAreaServicio = (colonia) => {
        let parametros = {
            paisId: colonia.pais?.id,
            estadoId: colonia.estado?.id,
            ciudadId: colonia.ciudad?.id,
            codigoPostal: colonia?.codigoPostal,
            empresaId: cliente?.empresaID,
            ClienteID: cliente?.id,
            ClienteDistribuidorID: value.distribuidor ? value.distribuidor.clienteDistribuidorID : 0
        };

        return parametros;
    }
    const setDatosRecoleccionGuardada = (areaServicio: AreaServicio, copiaRecoleccion: IRecoleccion, sucursal?: Sucursal) => {
        if (areaServicio.id > 0) {
            const esRadConCita = cliente.esRadConCita && areaServicio.esRadConCita;
            const esEadConCita = cliente.esEadConCita && areaServicio.esEadConCita;
            let serviciosAdicionales = obtenerServiciosAdicionales(areaServicio.serviciosAdicionales, false, esOrigen);
            const serviciosSeccionSevcios = serviciosAdicionales.filter(s => s.esSeccionServiciosAdicionales);
            const copiaAreaServicio = new AreaServicio({ ...areaServicio, serviciosAdicionales: serviciosSeccionSevcios });
            copiaAreaServicio.ObtenerGrupoHorarios();

            if (esOrigen && !esRadConCita) {
                serviciosAdicionales = serviciosAdicionales.filter(c => c.nombre !== 'CARGO POR CITA RAD')
            }
            if (!esOrigen && !esEadConCita) {
                serviciosAdicionales = serviciosAdicionales.filter(c => c.nombre !== 'CARGO POR CITA EAD')
            }

            if (solicitudCopia.serviciosAdicionales?.length && serviciosAdicionales.length) {
                if (localStorage["tipo_usuario"].toLowerCase() != "invitado") {
                    setRecoleccion({
                        ...copiaRecoleccion,
                        areaServicio: copiaAreaServicio,
                        sucursal: sucursal || new Sucursal(areaServicio.sucursal),
                        aceptaCita: ((esOrigen && esRadConCita) || (!esOrigen && esEadConCita)),
                        esForanea: areaServicio.esForanea,
                        serviciosAdicionales: serviciosAdicionales.filter(s => s.esSeccionOrigenDestino)

                    });
                }
                else {
                    setRecoleccion({ ...copiaRecoleccion, tipoRecoleccionId: undefined });
                    setTimeout(() => {
                        setRecoleccion({
                            ...copiaRecoleccion,
                            areaServicio: copiaAreaServicio,
                            sucursal: sucursal || new Sucursal(areaServicio.sucursal),
                            aceptaCita: ((esOrigen && esRadConCita) || (!esOrigen && esEadConCita)),
                            esForanea: areaServicio.esForanea,
                            serviciosAdicionales: serviciosAdicionales.filter(s => s.esSeccionOrigenDestino)

                        });
                    }, 500)
                }
            }
        }
        else{
            if(copiaRecoleccion.esServicioInternacional){
                setRecoleccion({
                    ...copiaRecoleccion,
                    aceptaCita: false,
                    serviciosAdicionales: [],
                    esComercioExterior: true,
                    esServicioInternacional: true
                });
            }
        }
    };

    type ModalidadCargoCita = "normal" | "fueraHorario" | "cedis" | null;

    const obtenerNombreServicio = (servicio: ServicioAdicional): string =>
        (servicio.nombre || servicio.concepto?.nombreConcepto || "")
            .trim()
            .toUpperCase();
    const copiarServicio = (servicio: ServicioAdicional): ServicioAdicional =>
        Object.assign(
            Object.create(Object.getPrototypeOf(servicio)),
            servicio
        ) as ServicioAdicional;
    /*
     * Conserva una sola copia de cada cargo de cita y deja seleccionado
     * únicamente el que corresponde a la modalidad actual. Si la lista local
     * viene vacía, recupera el objeto completo desde la solicitud o el catálogo
     * del área de servicio; así no se pierde el id, concepto ni configuración.
     */
    const sincronizarCargoPorCita = (
        recoleccionActualizada: IRecoleccion,
        modalidad: ModalidadCargoCita
    ): ServicioAdicional[] => {
        const nombresCargo = esOrigen
            ? {
                normal: "CARGO POR CITA RAD",
                fueraHorario: "FLETE CARGO RAD FUERA DE HORARIO",
                cedis: "CARGO POR CITA RAD CEDIS"
            }
            : {
                normal: "CARGO POR CITA EAD",
                fueraHorario: "FLETE CARGO EAD FUERA DE HORARIO",
                cedis: "CARGO POR CITA EAD CEDIS"
            };
        const nombreSeleccionado = modalidad
            ? nombresCargo[modalidad]
            : undefined;
        const nombresDeCita = new Set(Object.keys(nombresCargo).map(
            llave => nombresCargo[llave]
        ));
        const serviciosSolicitud = esOrigen
            ? solicitudCopia.serviciosAdicionalesOrigen
            : solicitudCopia.serviciosAdicionalesDestino;
        const serviciosBase = recoleccionActualizada.serviciosAdicionales?.length
            ? recoleccionActualizada.serviciosAdicionales
            : (serviciosSolicitud ?? []);
        const fuentes: Array<ServicioAdicional[] | undefined> = [
            recoleccionActualizada.serviciosAdicionales,
            serviciosSolicitud,
            solicitudCopia.serviciosAdicionales,
            recoleccion.areaServicio?.serviciosAdicionales as ServicioAdicional[] | undefined,
            value.serviciosAdicionales,
            value.areaServicio?.serviciosAdicionales as ServicioAdicional[] | undefined
        ];
        const nombresAgregados = new Set<string>();
        let cargoSeleccionadoAgregado = false;
        const serviciosSinDuplicados = serviciosBase.reduce(
            (resultado: ServicioAdicional[], servicio: ServicioAdicional) => {
                const nombreServicio = obtenerNombreServicio(servicio);
                if (!nombresDeCita.has(nombreServicio)) {
                    resultado.push(servicio);
                    return resultado;
                }
                if (nombresAgregados.has(nombreServicio)) {
                    return resultado;
                }
                nombresAgregados.add(nombreServicio);
                const copiaServicio = copiarServicio(servicio);
                const debeSeleccionarse = nombreServicio === nombreSeleccionado;
                copiaServicio.seleccionado = debeSeleccionarse;
                copiaServicio.aplicaOrigen = debeSeleccionarse && esOrigen;
                copiaServicio.aplicaDestino = debeSeleccionarse && !esOrigen;
                cargoSeleccionadoAgregado =
                    cargoSeleccionadoAgregado || debeSeleccionarse;
                resultado.push(copiaServicio);
                return resultado;
            },
            []
        );
        if (nombreSeleccionado && !cargoSeleccionadoAgregado) {
            let servicioCatalogo: ServicioAdicional | undefined;
            fuentes.some(fuente => {
                servicioCatalogo = fuente?.find(
                    servicio =>
                        obtenerNombreServicio(servicio) === nombreSeleccionado
                );
                return !!servicioCatalogo;
            });
            if (servicioCatalogo) {
                const copiaServicio = copiarServicio(servicioCatalogo);
                copiaServicio.seleccionado = true;
                copiaServicio.aplicaOrigen = esOrigen;
                copiaServicio.aplicaDestino = !esOrigen;
                serviciosSinDuplicados.push(copiaServicio);
            }
        }
        return serviciosSinDuplicados;
    };

    const updateRecoleccion = (valorPropiedad: any, nombrePropiedad: string) => {

        if (valorPropiedad) {
            let nuevaRecoleccion = { ...recoleccion, [nombrePropiedad]: valorPropiedad, completado: true };

            if (nombrePropiedad === 'fechaCita') {
                nuevaRecoleccion['aceptaCita'] = true;
                if(esOrigen){
                    nuevaRecoleccion['tipoDeRecoleccionOrigen'] = 2;
                    delete nuevaRecoleccion['EsCitaRadCedis']
                }
                else{
                    nuevaRecoleccion['tipoDeRecoleccionDestino'] = 2;
                    delete nuevaRecoleccion['EsCitaEadCedis']
                }                    

                nuevaRecoleccion.serviciosAdicionales =
                 sincronizarCargoPorCita(nuevaRecoleccion, "normal");
                delete nuevaRecoleccion['fechaRecoleccion'];
                delete nuevaRecoleccion['EsFueraHorario'];
                delete nuevaRecoleccion['horaFHDe'];
                delete nuevaRecoleccion['horaFHHasta'];
                delete nuevaRecoleccion['fechaCitaCedis'];
            }
            if (nombrePropiedad === 'fechaRecoleccion') {
                nuevaRecoleccion['aceptaCita'] = false;
                if(esOrigen){
                    nuevaRecoleccion['tipoDeRecoleccionOrigen'] = 1;
                    delete nuevaRecoleccion['EsCitaRadCedis']
                }
                else{
                    nuevaRecoleccion['tipoDeRecoleccionDestino'] = 1;
                    delete nuevaRecoleccion['EsCitaEadCedis']
                }
                delete nuevaRecoleccion['fechaCita'];
                delete nuevaRecoleccion['fechaCitaCedis'];
                delete nuevaRecoleccion['EsFueraHorario'];
                delete nuevaRecoleccion['horaFHDe'];
                delete nuevaRecoleccion['horaFHHasta'];
                nuevaRecoleccion.serviciosAdicionales =
                sincronizarCargoPorCita(nuevaRecoleccion, null);
            }
            if (nombrePropiedad === 'fechaCitaCedis') {
                //nuevaRecoleccion['aceptaCita'] = true;
                if(esOrigen)
                    nuevaRecoleccion['tipoDeRecoleccionOrigen'] = 4;
                else
                    nuevaRecoleccion['tipoDeRecoleccionDestino'] = 4;

                nuevaRecoleccion.serviciosAdicionales =
                sincronizarCargoPorCita(nuevaRecoleccion, "cedis");
                delete nuevaRecoleccion['fechaCita'];
                delete nuevaRecoleccion['fechaRecoleccion'];
                delete nuevaRecoleccion['EsFueraHorario'];
                delete nuevaRecoleccion['horaFHDe'];
                delete nuevaRecoleccion['horaFHHasta'];
            }
            actualizarSolicitudDesdeRecoleccion(
                    nuevaRecoleccion,
                    nombrePropiedad
                );
            setRecoleccion(nuevaRecoleccion);
        }
    };

    const updateRecoleccionNull = (valorPropiedad: any, nombrePropiedad: string) => {
        let nuevaRecoleccion = { ...recoleccion, [nombrePropiedad]: valorPropiedad, completado: true };

        setRecoleccion(nuevaRecoleccion);
    };

    const updateRecoleccionFueraHorario = (valorPropiedadFecha: any, nombrePropiedadFecha: string,
        valorPropiedadHoraDe: any, nombrePropiedadHoraDe: string, valorPropiedadHoraHasta: any, nombrePropiedadHoraHasta: string) => {
        if (valorPropiedadFecha) {
            let nuevaRecoleccion = { ...recoleccion, [nombrePropiedadFecha]: valorPropiedadFecha, [nombrePropiedadHoraDe]: valorPropiedadHoraDe, [nombrePropiedadHoraHasta]: valorPropiedadHoraHasta, ["EsFueraHorario"]: true, completado: true };

            if (nombrePropiedadFecha === 'fechaCita') {
                nuevaRecoleccion['aceptaCita'] = true;
                if(esOrigen){
                    nuevaRecoleccion['tipoDeRecoleccionOrigen'] = 3;
                    delete nuevaRecoleccion['EsCitaRadCedis']
                }
                else{
                    nuevaRecoleccion['tipoDeRecoleccionDestino'] = 3;
                    delete nuevaRecoleccion['EsCitaEadCedis']
                }
                delete nuevaRecoleccion['fechaRecoleccion'];
                delete nuevaRecoleccion['fechaCitaCedis'];
            }
            nuevaRecoleccion.serviciosAdicionales =
                sincronizarCargoPorCita(nuevaRecoleccion, "fueraHorario");

            actualizarSolicitudDesdeRecoleccion(
                nuevaRecoleccion,
                nombrePropiedadFecha
            );
            setRecoleccion(nuevaRecoleccion);
        }
    };

    const setDocumentos = (recoleccionActual: IRecoleccion) => {
        //Se obtinen los srvicios del destino en caso de estar en el origen, o los servicios del origen en caso contario
        const servicios = esOrigen ? props.recoleccionDestino.serviciosAdicionales : props.recoleccionOrigen.serviciosAdicionales;
        const retornoDocumentosSeleccionado = servicios?.find(e => e.esRetornoDocumentos && e.seleccionado);

        if (!retornoDocumentosSeleccionado || !recoleccionActual.serviciosAdicionales?.some(e => e.esRetornoDocumentos)) return

        // Reemplazo inmutable para no mutar objetos que ya viven en el store de Redux.
        recoleccionActual.serviciosAdicionales = recoleccionActual.serviciosAdicionales.map(s => {
            if (!s.esRetornoDocumentos) return s;
            const copia = copiarServicio(s);
            copia.documentos = retornoDocumentosSeleccionado.documentos;
            return copia;
        });
    }

    const setDatosRecoleccion = (areaServicio: AreaServicio, copiaRecoleccion: IRecoleccion, sucursal?: Sucursal) => {
        let esServicioInternacional = copiaRecoleccion.paisId === enums.pais.usa;
        if (areaServicio.id > 0) {
            completarValoresRecoleccion(copiaRecoleccion, areaServicio, cliente, esOrigen, sucursal);
            setDocumentos(copiaRecoleccion);

            if (recoleccion.areaServicio?.id === areaServicio.id) {
                copiaRecoleccion.serviciosAdicionales = recoleccion.serviciosAdicionales;
                copiaRecoleccion.recalcularServicios = false;
            } else {
                copiaRecoleccion.recalcularServicios = true;
            }
            let esPuertoAeropuerto = false;
            let esComercioExterior = esPuertoAeropuerto || esServicioInternacional;

            setRecoleccion({ ...copiaRecoleccion,
                esComercioExterior: esComercioExterior,
                esServicioInternacional: esServicioInternacional,
                eliminaRetornoDocumentos:  false
             });
        } else {
            setCPFueraArea(true);
            if (esServicioInternacional) {
                setRecoleccion({
                    ...copiaRecoleccion,
                    aceptaCita: false,
                    serviciosAdicionales: [],
                    tipoRecoleccionId: 1,
                    completado: true,
                    esComercioExterior: true,
                    esServicioInternacional: true,
                    eliminaRetornoDocumentos:  true
                });
            }
            else {
                swal.fire({
                    titleText: traducirMessage(276), // '¡Atención!',
                    text: traducirMessage(52), // "El código postal seleccionado esta fuera de nuestra área de servicio.\r\nFavor de elegir alguna de las sucursales Almex disponibles en el catálogo.",
                    type: 'warning',
                });
                setRecoleccion({ ...copiaRecoleccion,
                    esComercioExterior: false,
                    esServicioInternacional: false
                 });
            }
        }
    };

    const handlePais = (event) => {
        setRecoleccion({ ...initialRecoleccionState, paisId: event.target.value });
        setCodigoPostal(null);
    };
    
    const validaCriteriosRadEad = async() => {
        if(!esOrigen && cliente.habilitarValidacionCoberturaEAD){
            let paramsConv = {
                ClienteID: cliente?.id,
                AreaServicioId: distribuidor.ciudadId
            }
            let resultConv = await apiSource.obtenerAsync("convenio/convenios-eAD", paramsConv)
            if(Array.isArray(resultConv) && resultConv.length===0){
                swal.fire({
                    titleText: traducirMessage(272),
                    text: traducirMessage(307),
                    type: 'error',
                });
                setRecoleccion({
                    ...recoleccion, codigoPostal: "", contacto: { id: 0, nombre: "", departamento: "", puesto: "", telefono: "", correo: "" },
                    completado: false
                });
                setContacto({ id: 0, nombre: '', departamento: "", puesto: "", telefono: "", correo: "" });
                if(esOrigen)
                    setContactosDistribuidor({clienteId: 0, clienteDistribuidorId: 0, contactos: []});
                if(!esOrigen)
                    setContactosDistribuidorDestino({clienteId: 0, clienteDistribuidorId: 0, contactos: []});
                return false;
                
            }
            //alert("Realiza Validaciones de Cobertura, Cliente: "+params.ClienteID+' AreaServicio: '+params.ciudadId+' Empresa: '+params.empresaId);
        }

        if(esOrigen && cliente.habilitarValidacionCoberturaRAD){
            let paramsConv = {
                ClienteID: cliente?.id,
                AreaServicioId: distribuidor.ciudadId
            }
            let resultConv = await apiSource.obtenerAsync("convenio/convenios-rAD", paramsConv)
            if(Array.isArray(resultConv) && resultConv.length===0){
                swal.fire({
                    titleText: traducirMessage(272),
                    text: traducirMessage(308),
                    type: 'error',
                });
                setRecoleccion({
                    ...recoleccion, codigoPostal: "", contacto: { id: 0, nombre: "", departamento: "", puesto: "", telefono: "", correo: "" },
                    completado: false
                });
                setContacto({ id: 0, nombre: '', departamento: "", puesto: "", telefono: "", correo: "" });
                if(esOrigen)
                    setContactosDistribuidor({clienteId: 0, clienteDistribuidorId: 0, contactos: []});
                if(!esOrigen)
                    setContactosDistribuidorDestino({clienteId: 0, clienteDistribuidorId: 0, contactos: []});
                return false;
                
            }
            //alert("Realiza Validaciones de Cobertura, Cliente: "+params.ClienteID+' AreaServicio: '+params.ciudadId+' Empresa: '+params.empresaId);
        }

        return true;
    }

    const handleTipoRecoleccion = async (tipoRecoleccionId) => {

        if(tipoRecoleccionId !== 3){
            validaCriteriosRadEad().then(res => {
                if(!res){
                    return;
                }
            });
        }
        
        if (cpFueraArea && !recoleccion.esServicioInternacional) {
            swal.fire({
                titleText: traducirMessage(276), // '¡Atención!',
                text: traducirMessage(193), // "No contamos con oficina en la población solicitada, favor de seleccionar la oficina ocurre más conveniente a su ubicación, haga clic en buscar opciones para seleccionar la oficina más conveniente",
                type: 'error',
            });
        }

        if (recoleccion.areaServicio?.esForanea && tipoRecoleccionId === enums.tipoRecoleccion.ocurre) {
            swal.fire({
                titleText: traducirMessage(276), // '¡Atención!',
                text: traducirMessage(151), // "La población seleccionada solo cuenta con servicio de Recolección a Domicilio, para ofrecer el servicio Ocurre deberá elegir alguna de las sucursales Almex disponibles en el catálogo.",
                type: 'warning',
            });
        }

        const esOcurre = tipoRecoleccionId === enums.tipoRecoleccion.ocurre;
        const cambiarAreaServicio = esOcurre || recoleccion.tipoRecoleccionId === enums.tipoRecoleccion.ocurre;

        if (!cambiarAreaServicio || (cpFueraArea && !recoleccion.esServicioInternacional)) {
            updateRecoleccion(tipoRecoleccionId, "tipoRecoleccionId");
            return;
        }

        let result;

        if (esOcurre) {
            const areaServicioId = recoleccion.sucursal?.ocurreAreaServicioId || 0;
            result = await apiSource.obtenerPorIdAsync("area-servicio", areaServicioId);
        } else {
            const coloniaIds = recoleccion.colonia?.ObtenerIds();
            let parameters = obtenerParametrosAreaServicio(recoleccion.colonia);
            result = await apiSource.obtenerAsync("area-servicio/by-address-cliente-distribuidor", parameters);
        }

        const areaServicio = new AreaServicio(result);
        console.log(result);
        const copiaRecoleccion = { ...recoleccion, tipoRecoleccionId, completado: true };

        setDatosRecoleccion(areaServicio, copiaRecoleccion);
    };

    const handleSolicitarDeNuevo = (solicita: boolean | null, seleccion: number | null) => {
        // const copiaSolicitud = new Solicitud({ ...solicitudCopia, tipoSeleccionDestino: (seleccion ? seleccion : 1), 
        //     tipoDeRecoleccionDestino: undefined, tipoDeRecoleccionOrigen: undefined  });
        const copiaSolicitud = new Solicitud({ ...solicitudCopia, tipoDeRecoleccionDestino: undefined });
        props.setSolicitudCopia(copiaSolicitud);
        setSolicitudCopia(copiaSolicitud);
    }

    const handleSolicitarDeNuevoOrigen = (solicita: boolean | null, seleccion: number | null) => {
        const copiaSolicitud = new Solicitud({ ...solicitudCopia, tipoDeRecoleccionOrigen: undefined });
        props.setSolicitudCopia(copiaSolicitud);
        setSolicitudCopia(copiaSolicitud);
    }
    
    const handleSolicitudOption = (seleccion: number | null) => {
        const copiaSolicitud = new Solicitud({ ...solicitudCopia, tipoSeleccionDestino: (seleccion ? seleccion : 1) });
        props.setSolicitudCopia(copiaSolicitud);
        setSolicitudCopia(copiaSolicitud);
    }
    
    const handleFecha = (fecha: Date | null) => {
        updateRecoleccion(fecha, "fechaCita");
        if (fecha == null) {
            updateRecoleccionNull(null, "fechaCita");
        }
    };

    const handleFechaCedis = (fecha: Date | null) => {
        updateRecoleccion(fecha, "fechaCitaCedis");
        if (fecha == null) {
            updateRecoleccionNull(null, "fechaCitaCedis");
        }
    };

    const actualizarSolicitudDesdeRecoleccion = (
        recoleccionActualizada: IRecoleccion,
        nombrePropiedad: string
    ) => {
        const copiaSolicitud = new Solicitud(solicitudCopia);

        const serviciosActualizados =
            obtenerServiciosActuales(recoleccionActualizada);

        /*
        * También colocamos los servicios en la recolección para que ambos
        * objetos manejen la misma lista.
        */
        recoleccionActualizada.serviciosAdicionales = [
            ...serviciosActualizados
        ];

        if (esOrigen) {
            copiaSolicitud.serviciosAdicionalesOrigen = [
                ...serviciosActualizados
            ];

            if (nombrePropiedad === "fechaCitaCedis") {
                copiaSolicitud.tipoDeRecoleccionOrigen = 4;

                copiaSolicitud.fechaCitaRadCedis =
                    recoleccionActualizada.fechaCitaCedis;

                // Limpiar la modalidad anterior.
                copiaSolicitud.fechaCitaRad = undefined;
                copiaSolicitud.EsRadCitaFueraHorario = false;
                copiaSolicitud.RadCitaHoraDe = undefined;
                copiaSolicitud.RadCitaHoraHasta = undefined;
            }
        } else {
            copiaSolicitud.serviciosAdicionalesDestino = [
                ...serviciosActualizados
            ];

            if (nombrePropiedad === "fechaCitaCedis") {
                copiaSolicitud.tipoDeRecoleccionDestino = 4;

                copiaSolicitud.fechaCitaEadCedis =
                    recoleccionActualizada.fechaCitaCedis;

                // Limpiar la modalidad anterior.
                copiaSolicitud.fechaCitaEad = undefined;
                copiaSolicitud.EsEadCitaFueraHorario = false;
                copiaSolicitud.EadCitaHoraDe = undefined;
                copiaSolicitud.EadCitaHoraHasta = undefined;
            }
        }
        props.setSolicitudCopia(copiaSolicitud);
        props.setSolicitud(new Solicitud(copiaSolicitud));
    };

    const obtenerServiciosActuales = (
        recoleccionActualizada: IRecoleccion
    ): ServicioAdicional[] => {
        // Primera opción: servicios del estado local.
        if (
            Array.isArray(recoleccionActualizada.serviciosAdicionales)
        ) {
            return [
                ...recoleccionActualizada.serviciosAdicionales
            ];
        }

        // Segunda opción: servicios ya guardados por origen o destino.
        const serviciosSolicitud = esOrigen
            ? solicitudCopia.serviciosAdicionalesOrigen
            : solicitudCopia.serviciosAdicionalesDestino;

            if (
            serviciosSolicitud &&
            serviciosSolicitud.length > 0
        ) {
            return [...serviciosSolicitud];
        }

        // Tercera opción: catálogo general de servicios.
        if (
            solicitudCopia.serviciosAdicionales &&
            solicitudCopia.serviciosAdicionales.length > 0
        ) {
            return [...solicitudCopia.serviciosAdicionales];
        }

        return [];
    };

    const handleFechaRecoleccion = (fecha: Date | null, esEad = false) => {
        let nuevaRecoleccion = { ...recoleccion, completado: true};
        if(esOrigen){
            nuevaRecoleccion['tipoDeRecoleccionOrigen'] = 1;
            delete nuevaRecoleccion['EsCitaRadCedis']
            if(!recoleccion.fechaRecoleccion || recoleccion.fechaRecoleccion !== fecha)
                setLoading(true);
        }
        else{
            nuevaRecoleccion['tipoDeRecoleccionDestino'] = 1;
            delete nuevaRecoleccion['EsCitaEadCedis']
        }
        nuevaRecoleccion.serviciosAdicionales =
            sincronizarCargoPorCita(nuevaRecoleccion, null);
        delete nuevaRecoleccion['fechaCita'];
        delete nuevaRecoleccion['fechaCitaCedis'];
        delete nuevaRecoleccion['EsFueraHorario'];
        delete nuevaRecoleccion['horaFHDe'];
        delete nuevaRecoleccion['horaFHHasta'];
        if (fecha !== null) {
            setTimeout(() => {
                setRecoleccion({ ...nuevaRecoleccion, fechaRecoleccion: fecha });
            }, 500);

        }
        if(fecha === null && esEad) {
            setRecoleccion({ ...nuevaRecoleccion, EsCitaEadCedis: false});
        }
    };
    const handleFechaFueraHorario = (fecha: Date | null, horaDe: string | null, horaHasta: string | null) => {
        updateRecoleccionFueraHorario(fecha, "fechaCita", horaDe, "horaFHDe", horaHasta, "horaFHHasta");
    }

    const handleSucursal = async (sucursal: Sucursal) => {
        setRecoleccion({ ...recoleccion, sucursal, completado: true });

        if (sucursal.ocurreAreaServicioId) {
            const result: AreaServicio = await apiSource.obtenerPorIdAsync("area-servicio", sucursal.ocurreAreaServicioId);
            const areaServicio: AreaServicio = new AreaServicio(result);
            setDatosRecoleccion(areaServicio, recoleccion, sucursal);
        }
    };

    const handleServicio = (servicio: ServicioAdicional) => {
        const nuevosServicios = recoleccion.serviciosAdicionales?.map(sa => sa.id !== servicio.id ? sa : servicio);
        updateRecoleccion(nuevosServicios, "serviciosAdicionales");
    };

    const cerrarNuevaDireccion = () => {
        setNuevaDireccion(false);
    };

    const cerrarNuevoContacto = () => {
        setNuevoContacto(false);
    };

    const cerrarBusqueda = () => {
        setBuscarDistribuidor(false);
    };

    const cerrarBusquedaContacto = () => {
        setBuscarContactos(false);
    };

    const getDistribuidor = (distribuidor) => {
        handleCodigoPostal(null, distribuidor);
    }

    const getDistribuidorComplemento = (distribuidor) => {
        handleCodigoPostal(null, distribuidor);
    }

    const buscarDistribuidor = () => {
        setBuscarDistribuidor(true);
        setBuscarContactos(false);
    };
    const buscarContacto = () => {
        setBuscarContactos(true);
        setBuscarDistribuidor(false);
    };

    const nuevaDireccion = () => {
        setNuevaDireccion(true);
    }

    const nuevoContacto = () => {
        setNuevoContacto(true);
    }

    const handleCodigoPostal = async (event, optionSelected) => {
        if(event && event.type == 'click')
        {
            setRecoleccion(
            {
                ...recoleccion, codigoPostal: "", contacto: { id: 0, nombre: "", departamento: "", puesto: "", telefono: "", correo: "" },
                completado: false
            });
        }
        setCPFueraArea(false);
        setCodigoPostal(optionSelected);

        if (optionSelected != null) {
            const colonia = new Colonia(optionSelected.colonium);
            const distribuidor = {
                id: optionSelected.clienteDistribuidorID ?? optionSelected.clienteDistribuidorId,
                nombre: optionSelected.nombreClienteDistribuidor ?? optionSelected.nombre,
                direccion: (optionSelected.direccion === "") ? getDireccionDistribuidor(optionSelected) : optionSelected.direccion,
                clienteDistribuidorID: optionSelected.clienteDistribuidorID ?? optionSelected.clienteDistribuidorId,
                colonia: optionSelected.colonium,
                codigoPostal: optionSelected.codigoPostal,
                paisId: optionSelected.paisID,
                estadoId: optionSelected.estadoID,
                ciudadId: optionSelected.ciudadID,
                calle: optionSelected.calle,
                noExterior: optionSelected.noExterior
            }

            setDistribuidor(distribuidor);

            if (!optionSelected.clienteDistribuidorComplementos && cliente.habilitarDatosComplementarios) {
                setShowModalDatosComplementarios(true);
                return;
            }

            let id = optionSelected.clienteDistribuidorID ? optionSelected.clienteDistribuidorID : optionSelected.clienteDistribuidorId;
            getContactos(id).then(res => {
                if(esOrigen)
                    setContactosDistribuidor({clienteId: cliente.id, clienteDistribuidorId: id, contactos: res});
                if(!esOrigen)
                    setContactosDistribuidorDestino({clienteId: cliente.id, clienteDistribuidorId: id, contactos: res});
            });

            setContacto({ id: 0, nombre: '', departamento: "", puesto: "", telefono: "", correo: "" });
            //let parameters = obtenerParametrosAreaServicio(colonia);
            let params ={
                paisId: colonia.pais?.id,
                estadoId: colonia.estado?.id,
                ciudadId: colonia.ciudad?.id,
                codigoPostal: colonia?.codigoPostal,
                empresaId: cliente?.empresaID,
                ClienteID: cliente?.id,
                ClienteDistribuidorID: optionSelected.clienteDistribuidorID
            };

            if (cotizacionId == 0) {
                let result: AreaServicio = await apiSource.obtenerAsync("area-servicio/by-address-cliente-distribuidor", params);
                const areaServicio: AreaServicio = new AreaServicio(result);
                if (result.recintoAduanal && result.recintoAduanal.length > 0) {
                    if(result.recintoAduanal[0].tipoRecintoID == 1){
                        swal.fire({
                            titleText: traducirMessage(11),
                            text: traducirMessage(319),
                            type: 'info',
                        });
                    }
                    else if (result.recintoAduanal[0].tipoRecintoID == 2){
                        swal.fire({
                            titleText: traducirMessage(11),
                            text: traducirMessage(318),
                            type: 'info',
                        });
                    }
                    
                }
                //Limpia la recolección y pone los valores del código postal seleccionado
                const nuevaRecoleccion = {
                    ...initialRecoleccionState,
                    paisId: optionSelected.paisID,
                    colonia: colonia,
                    direccion: colonia.direccion,
                    codigoPostal: colonia.codigoPostal,
                    sinAreaServicio: areaServicio.id === 0,
                    distribuidor,
                    contacto: null,
                    serviciosAdicionales: solicitudCopia.serviciosAdicionales,
                    esComercioExterior: false,
                    esServicioInternacional: false
                };

                if (recoleccion.areaServicio?.id === areaServicio.id) {
                    nuevaRecoleccion.tipoRecoleccionId = recoleccion.tipoRecoleccionId;
                    nuevaRecoleccion.sucursal = recoleccion.sucursal;
                    nuevaRecoleccion.completado = true;
                    nuevaRecoleccion.EsFueraHorario = recoleccion.EsFueraHorario;
                    nuevaRecoleccion.fechaCita = recoleccion.fechaCita;
                    nuevaRecoleccion.fechaCitaCedis = recoleccion.fechaCitaCedis;
                    nuevaRecoleccion.horaFHDe = recoleccion.horaFHDe;
                    nuevaRecoleccion.horaFHHasta = recoleccion.horaFHHasta;
                    nuevaRecoleccion.serviciosAdicionales = solicitudCopia.serviciosAdicionales;
                }

                if(recoleccion.EsCitaRadCedis !== undefined){
                    nuevaRecoleccion.EsCitaRadCedis = true;
                }

                if(recoleccion.EsCitaEadCedis !== undefined){
                    nuevaRecoleccion.EsCitaEadCedis = true;
                }

                if(esOrigen && recoleccion.fechaCitaCedis!==undefined){
                    nuevaRecoleccion.EsCitaRadCedis = true;    
                }

                if(!esOrigen && recoleccion.fechaCitaCedis!==undefined){
                    nuevaRecoleccion.EsCitaEadCedis = true;    
                }

                setDatosRecoleccion(areaServicio, nuevaRecoleccion);
            } else {
                const result: AreaServicio = await apiSource.obtenerAsync("area-servicio/by-address-cliente-distribuidor", params);
                const areaServicio: AreaServicio = new AreaServicio(result);
                setDatosRecoleccion(areaServicio, value);
            }
        } else {
            setRecoleccion({
                ...recoleccion, codigoPostal: "", contacto: { id: 0, nombre: "", departamento: "", puesto: "", telefono: "", correo: "" },
                completado: false
            });
            setContacto({ id: 0, nombre: '', departamento: "", puesto: "", telefono: "", correo: "" });
            if(esOrigen)
                setContactosDistribuidor({clienteId: 0, clienteDistribuidorId: 0, contactos: []});
            if(!esOrigen)
                setContactosDistribuidor({clienteId: 0, clienteDistribuidorId: 0, contactos: []});
        }
    };


    const handleCodigoPostalRender = async (event, optionSelected) => {
        setCPFueraArea(false);
        setCodigoPostal(optionSelected);

        if (optionSelected != null) {
            const colonia = new Colonia(optionSelected.colonium);
            const distribuidor = {
                id: optionSelected.clienteDistribuidorID ?? optionSelected.clienteDistribuidorId,
                nombre: optionSelected.nombreClienteDistribuidor ?? optionSelected.nombre,
                direccion: (optionSelected.direccion === "") ? getDireccionDistribuidor(optionSelected) : optionSelected.direccion,
                clienteDistribuidorID: optionSelected.clienteDistribuidorID ?? optionSelected.clienteDistribuidorId,
                colonia: optionSelected.colonium,
                codigoPostal: optionSelected.codigoPostal,
                paisId: optionSelected.paisID,
                estadoId: optionSelected.estadoID,
                ciudadId: optionSelected.ciudadID,
                calle: optionSelected.calle,
                noExterior: optionSelected.noExterior
            }

            setDistribuidor(distribuidor);

            if (!optionSelected.clienteDistribuidorComplementos && cliente.habilitarDatosComplementarios) {
                setShowModalDatosComplementarios(true);
                return;
            }
            let id = optionSelected.clienteDistribuidorID ? optionSelected.clienteDistribuidorID : optionSelected.clienteDistribuidorId;
            getContactos(id).then(res => {
                //setContactosDistribuidor(res);
                if(esOrigen)
                    setContactosDistribuidor({clienteId: cliente.id, clienteDistribuidorId: id, contactos: res});
                if(!esOrigen)
                    setContactosDistribuidor({clienteId: cliente.id, clienteDistribuidorId: id, contactos: res});
                res.forEach(async contact => {
                    if(contacto.id === contact.clienteDistribuidorContactoID){
                        //handleContacto(contact);
                        let contactoD = contact ?
                            {
                                id: contact.clienteDistribuidorContactoID,
                                nombre: contact.nombreClienteDistribuidorContacto || contact.nombre,
                                nombreClienteDistribuidorContacto: contact.nombreClienteDistribuidorContacto || contact.nombre,
                                puesto: contact.puesto,
                                departamento: contact.departamento,
                                telefono: contact.telefono,
                                correo: contact.correo,
                                clienteDistribuidorID: contact.clienteDistribuidorID
                            }
                            : null;
                        setContacto(contactoD);
                        let params ={
                            paisId: colonia.pais?.id,
                            estadoId: colonia.estado?.id,
                            ciudadId: colonia.ciudad?.id,
                            codigoPostal: colonia?.codigoPostal,
                            empresaId: cliente?.empresaID,
                            ClienteID: cliente?.id,
                            ClienteDistribuidorID: optionSelected.clienteDistribuidorID
                        };
                        if (cotizacionId == 0) {
                            let result: AreaServicio = await apiSource.obtenerAsync("area-servicio/by-address-cliente-distribuidor", params);
                            const areaServicio: AreaServicio = new AreaServicio(result);
            
                            //Limpia la recolección y pone los valores del código postal seleccionado
                            const nuevaRecoleccion = {
                                ...initialRecoleccionState,
                                paisId: optionSelected.paisID,
                                colonia: colonia,
                                direccion: colonia.direccion,
                                codigoPostal: colonia.codigoPostal,
                                sinAreaServicio: areaServicio.id === 0,
                                distribuidor,
                                contacto: contactoD,
                                serviciosAdicionales: solicitudCopia.serviciosAdicionales
                            };
            
                            if (recoleccion.areaServicio?.id === areaServicio.id) {
                                nuevaRecoleccion.tipoRecoleccionId = recoleccion.tipoRecoleccionId;
                                nuevaRecoleccion.sucursal = recoleccion.sucursal;
                                nuevaRecoleccion.completado = true;
                                nuevaRecoleccion.EsFueraHorario = recoleccion.EsFueraHorario;
                                nuevaRecoleccion.fechaCita = recoleccion.fechaCita;
                                nuevaRecoleccion.fechaCitaCedis = recoleccion.fechaCitaCedis;
                                nuevaRecoleccion.horaFHDe = recoleccion.horaFHDe;
                                nuevaRecoleccion.horaFHHasta = recoleccion.horaFHHasta;
                                nuevaRecoleccion.serviciosAdicionales = solicitudCopia.serviciosAdicionales;
                            }
            
                            setDatosRecoleccion(areaServicio, nuevaRecoleccion);
                            setLoading(false);
                        } else {
                            const result: AreaServicio = await apiSource.obtenerAsync("area-servicio/by-address-cliente-distribuidor", params);
                            const areaServicio: AreaServicio = new AreaServicio(result);
                            setDatosRecoleccion(areaServicio, value);
                            setLoading(false);
                        }
                    }        
                });
            });
        } else {
            setRecoleccion({
                ...recoleccion, codigoPostal: "", contacto: { id: 0, nombre: "", departamento: "", puesto: "", telefono: "", correo: "" },
                completado: false
            });
            setContacto({ id: 0, nombre: '', departamento: "", puesto: "", telefono: "", correo: "" });
            if(esOrigen)
                setContactosDistribuidor({clienteId: 0, clienteDistribuidorId: 0, contactos: []});
            if(!esOrigen)
                setContactosDistribuidor({clienteId: 0, clienteDistribuidorId: 0, contactos: []});
            setLoading(false);
        }
    };

    const handleContacto = (value) => {
        let contacto = value ?
            {
                id: value.id || value.clienteDistribuidorContactoID,
                nombre: value.nombreClienteDistribuidorContacto || value.nombre,
                nombreClienteDistribuidorContacto: value.nombreClienteDistribuidorContacto || value.nombre,
                puesto: value.puesto,
                departamento: value.departamento,
                telefono: value.telefono,
                correo: value.correo,
                clienteDistribuidorID: value.clienteDistribuidorID
            }
            : null;
        const copiaRecoleccion = { ...recoleccion, contacto: contacto };

        setRecoleccion(copiaRecoleccion);
        setContacto(contacto);
    }

    const getContactos = async (clienteDistribuidorId) => {
        const result = await apiSource.obtenerAsync<any>("cliente-distribuidor-contacto/by-distribuidor-client-id", { clienteId: cliente.id, clienteDistribuidorID: clienteDistribuidorId });
        return result;
    };

    const cerrarDatosComplementarios = () => {
        setShowModalDatosComplementarios(false);
    };

    const confirmarDatosComplementarios = () => {
        setShowModalDatosComplementarios(false);
    };

    const continuar = () => {
        if (solicitudCopia.tipoSeleccionDestino === 3) {
            if (!recoleccion.fechaCita && !recoleccion.fechaCitaCedis) {
                enqueueSnackbar(traducirMessage(305), //"Selecciona la fecha y hora de entrega fuera de horario", 
                    { variant: "error" });
                return;
            }
        }
        if (solicitudCopia.tipoSeleccionDestino === 2 || solicitudCopia.tipoSeleccionDestino === 4) {
            if (!recoleccion.fechaCita && !recoleccion.fechaCitaCedis) {
                enqueueSnackbar(traducirMessage(238), //"Selecciona la fecha y hora de entrega", 
                    { variant: "error" });
                return;
            }
        }
        const servicioSinCantidad = recoleccion.serviciosAdicionales?.some(e => e.CantidadInvalida());
        const servicioSinCosto = recoleccion.serviciosAdicionales?.some(e => e.CostoInvalido());

        if (servicioSinCantidad || servicioSinCosto || !recoleccion.contacto) {
            let error = !recoleccion.contacto ? traducirMessage(110) : // "Favor de seleccionar contacto." :
                servicioSinCantidad ? traducirMessage(103) // "Favor de ingresar una cantidad en todos los servicios adicionales seleccionados."
                    : traducirMessage(99); //"Favor de capturar un costo en la sección de adicionales";
            enqueueSnackbar(error, { variant: "error" });

            return;
        }
        if(recoleccion.tipoRecoleccionId !== 3){
            validaCriteriosRadEad().then(res => {
                if(res){
                    siguientePaso(recoleccion, esOrigen, contacto);
                }
            });
        }
        else{
            siguientePaso(recoleccion, esOrigen, contacto);
        }
        
    }

    const mostrarDistribuidores = esOrigen ? cliente.esMostrarDistribuidoresRemitente : cliente.esMostrarDistribuidoresDestinatario;

    return (<>
        <Grid item xs={12}>
            {
                esOrigen
                    ? <Help comments={traducirMessage(37)} customStyle={{ top: "-10px", right: "-15px" }} />
                    : <Help comments={traducirMessage(36)} customStyle={{ top: "-10px", right: "-15px" }} />
            }
        </Grid>

        <Box mb={2} className="title">
            <Grid item xs={12} sm={6} lg={4}>
                {esOrigen ? traducirMessage(19) : traducirMessage(29)}
            </Grid>
        </Box>
        <br />
        <Grid container spacing={2} alignItems="center">
            <Grid item sm={2}>
                <strong>
                    {/* País */
                    traducirLabel(224)}
                </strong>
                <FormControl fullWidth>
                    <Select onChange={handlePais}
                        fullWidth disabled={true}
                        labelId="pais-label"
                        variant="outlined"
                        id="pais"
                        label={traducirLabel(224)} /*"País"*/
                        value={distribuidor.paisId}>
                        {localStorage.getItem("idioma") === 'en-US' && paises !== null && paises.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.etiquetaPais.nombre}
                            </MenuItem>
                        ))}
                        {localStorage.getItem("idioma") !== 'en-US' && paises !== null && paises.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                                {option.nombre}
                            </MenuItem>
                        ))}    
                        
                    </Select>
                </FormControl>
            </Grid>
            <Grid item sm={8}>
                <strong>{traducirMessage(164)}</strong>
                <AutocompleteControlSolicitud name="codigoPostal"
                    source="cliente-distribuidor/by-codigo-postal"
                    label=""
                    value={codigoPostal}
                    variant="outlined"
                    onChange={handleCodigoPostal}
                    filter={{ paisId: 0, clienteId: cliente.id, userName: usuario.nombre, esOrigen: esOrigen }} />
            </Grid>

            <Grid item xs={1}>
                <Button className={classes.icon} color="primary" variant="contained" onClick={() => buscarDistribuidor()} >
                    <Search />
                </Button>
            </Grid>
            <Grid item xs={1}>
                {  !mostrarDistribuidores && cliente.esPermitirAgregarDirecciones &&
                    <Button className={classes.icon} color="primary" variant="contained" onClick={() => nuevaDireccion()} >
                        <Add />
                    </Button>
                }
            </Grid>
        </Grid>
        {recoleccion.codigoPostal !== "" &&
            <Grid container spacing={2} alignItems="center">
                <Grid item sm={2} />
                <Grid item sm={8}>
                    <Box display="flex" flexDirection="column" fontSize={14}>
                        <Box fontWeight="fontWeightMedium">
                            {distribuidor.nombre != "" ? distribuidor.nombre : recoleccion.distribuidor?.nombre}
                        </Box>
                        <Box fontWeight="fontWeightLight" fontSize={10}>
                            {!!distribuidor.direccion ? distribuidor.direccion : recoleccion.direccion}
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        }

        <br />

        <Grid container spacing={2} alignItems="center">
            <Grid item sm={2} />
            <Grid item sm={8}>
                <InputLabel id="direccionOrigen-label" className={classes.label}>
                    {/* Contacto */
                    traducirLabel(50)}
                </InputLabel>
                {!recoleccion.distribuidor?.clienteDistribuidorID &&
                    <TextField id={esOrigen ? 'Contacto-label-origen' : 'Contacto-label-destino'}
                        value={contacto?.nombre}
                        variant="outlined" fullWidth
                        disabled />
                }
                {recoleccion.distribuidor?.clienteDistribuidorID > 0 &&
                    <Autocomplete
                        options={esOrigen ? contactosDistribuidor.contactos : contactosDistribuidorDestino.contactos}
                        getOptionLabel={(option) => option.nombreClienteDistribuidorContacto}
                        value={recoleccion.contacto}
                        onChange={(event, value) => handleContacto(value)}
                        renderInput={(params) => <TextField  {...params} variant="outlined" />}
                    />
                }

                <Box display="flex" flexDirection="column" fontSize={14}>
                    <Box fontWeight="fontWeightMedium">
                        {recoleccion.contacto?.nombre}
                    </Box>
                    <Box fontWeight="fontWeightLight" fontSize={10}>
                        {recoleccion.contacto?.telefono} {recoleccion.contacto?.correo ? '/' : ''}{recoleccion.contacto?.correo}
                    </Box>
                </Box>
            </Grid>

            <Grid item xs={1}>
                <Button className={classes.icon} color="primary" variant="contained" onClick={() => buscarContacto()} disabled={distribuidor.clienteDistribuidorID == 0}>
                    <Search />
                </Button>
            </Grid>
            <Grid item xs={1}>
                <Button className={classes.icon} color="primary" variant="contained" onClick={() => nuevoContacto()} disabled={distribuidor.clienteDistribuidorID == 0} >
                    <Add />
                </Button>
            </Grid>
        </Grid>

        {recoleccion.codigoPostal !== "" &&
            <>
                <Box mt={2} mb={1} className="title-2">
                    {/* Seleccione el tipo de Ubicación */
                    traducirMessage(244)}
                </Box>

                <Grid container spacing={2}>
                    <TipoRecoleccionLista value={recoleccion.tipoRecoleccionId} onClick={handleTipoRecoleccion}
                        recoleccion={recoleccion} mostrarResidencial={true} esOrigen={esOrigen} ayuda={ayuda} idiomaId={""} 
                        mostrarSoloTipos={recoleccion.esServicioInternacional ?[1,2]:undefined }/>
                </Grid>

                {recoleccion.tipoRecoleccionId &&
                    (recoleccion.tipoRecoleccionId === enums.tipoRecoleccion.ocurre ?
                        <SucursalComponente value={recoleccion.sucursal} esOrigen={esOrigen} onChange={handleSucursal} />
                        : <RecoleccionFecha
                            esOrigen={esOrigen}
                            setFecha={handleFecha}
                            setFechaRecoleccion={handleFechaRecoleccion}
                            setFechaFH={handleFechaFueraHorario}
                            aceptaCita={recoleccion.aceptaCita && !recoleccion.esServicioInternacional}
                            value={recoleccion.fechaCita}
                            valueCedis={(recoleccion.fechaCitaCedis === undefined) ? 
                                (((recoleccion.EsCitaRadCedis !== undefined && recoleccion.EsCitaRadCedis) || (recoleccion.EsCitaEadCedis !== undefined && recoleccion.EsCitaEadCedis)) 
                                ? recoleccion.fechaCita : recoleccion.fechaCitaCedis) : recoleccion.fechaCitaCedis}
                            valueRecoleccion={recoleccion.fechaRecoleccion}
                            esSolicitud={true}
                            areaServicio={recoleccion.areaServicio}
                            horarios={recoleccion.areaServicio?.grupoHorarios}
                            cliente={cliente}
                            ayuda={ayuda}
                            horarioArea={recoleccion.areaServicio?.horarios}
                            valueHoraDe={recoleccion.horaFHDe}
                            valueHoraHasta={recoleccion.horaFHHasta}
                            EsFueraHorario={recoleccion.EsFueraHorario}
                            solicitudCopia={solicitudCopia}
                            recoleccion={recoleccion}
                            setFechaCedis={handleFechaCedis}
                            setSolicitaDeNuevoDestino ={handleSolicitarDeNuevo}
                            setSolicitaDeNuevoOrigen={handleSolicitarDeNuevoOrigen}
                            recoleccionOrigen={props.recoleccionOrigen}
                            setTipoDeRecoleccionOrigen={
                                handleTipoDeRecoleccionOrigen
                            }
                        />
                    )
                }

                {
                    recoleccion.completado && recoleccion.serviciosAdicionales && 
                    recoleccion.serviciosAdicionales.filter(s => !(esOrigen && s.id === 5)).length > 0 &&
                    <>
                        <Box mt={2} mb={1} className="title-2">
                            {/* ¿Requiere Servicios Adicionales? */
                            traducirMessage(30)}
                        </Box>
                        {recoleccion.serviciosAdicionales.length &&
                            <ServicioAdicionalLista servicios={recoleccion.serviciosAdicionales}
                                paisId={recoleccion.paisId} esOrigen={esOrigen}
                                onSelect={handleServicio} solicitud={solicitudCopia} ayuda={ayuda} />
                        }
                    </>
                }
            </>
        }

        {recoleccion.completado && (!cpFueraArea || cpFueraArea && recoleccion.esServicioInternacional || !!recoleccion.sucursal) &&
            <NextButton nextStep={continuar} />
        }

        {
            buscaDistribuidor &&
            <RecoleccionDireccion abierto={buscaDistribuidor} cerrar={cerrarBusqueda} confirmar={cerrarBusqueda} setDistribuidor={getDistribuidor}
                cliente={cliente} esOrigen={esOrigen} ayuda={ayuda} usuario={usuario} />
        }

        {
            buscaContactos &&
            <RecoleccionContacto abierto={buscaContactos} cerrar={cerrarBusquedaContacto} esOrigen={esOrigen}
                confirmar={cerrarBusquedaContacto} distribuidor={distribuidor} setContacto={handleContacto} cliente={cliente} usuario={usuario} ayuda={ayuda} />
        }

        {
            agregaDireccion &&
            <AgregarDireccion abierto={agregaDireccion} cerrar={cerrarNuevaDireccion} confirmar={cerrarNuevaDireccion} cliente={cliente} usuario={usuario}
                esOrigen={esOrigen ? 1 : 0} esDestino={esOrigen ? 0 : 1}
                setDistribuidor={getDistribuidor} />
        }

        {
            agregaContacto &&
            <AgregarContacto abierto={agregaContacto} cerrar={cerrarNuevoContacto} confirmar={cerrarNuevoContacto} cliente={cliente} usuario={usuario}
                distribuidor={recoleccion.distribuidor} setContacto={handleContacto} ayuda={ayuda} />
        }

        {showModalDatosComplementarios &&
            <DatosComplementarios abierto={showModalDatosComplementarios} cerrar={cerrarDatosComplementarios}
                setDatos={getDistribuidorComplemento}
                confirmar={confirmarDatosComplementarios} cliente={cliente} usuario={usuario}
                clienteDistribuidor={codigoPostal} />
        }
        {showLoading &&
            /*Procesando */
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    solicitudCopia: state.solicitudCopia,
    usuario: state.usuario,
    ayuda: state.ayuda,
    paises: state.paises,
    recoleccionOrigen: state.recoleccionOrigen,
    recoleccionDestino: state.recoleccionDestino,
    setSolicitud: state.solicitud
});

const mapDispatchToProps = {
    setSolicitudCopia: setSolicitudCopia,
    setSolicitud: setSolicitud,
    saveCliente: saveCliente
};


export default connect(mapStateToProps, mapDispatchToProps)(RecoleccionSolicitud);
